import AuthService from '../../utils/AuthService';
import { NotificationManager } from 'react-notifications';
import { browserHistory } from 'react-router';
import { setCookie } from '../../utils/Helper';

export const MitIdSuccessHandler = (
    params,
    logIn,
    userId,
    loginUser = () => {}
) => {
    const stayOnPrevPage = localStorage.getItem('stay_on_prev_page');

    if (params?.type === 'signup') {
        AuthService.register()
            .then((res) => {
                if (res.success) {
                    setCookie('isItInitialLogin', 'true', 90);
                    NotificationManager.success(
                        '',
                        'Velkommen til Bet25 Sport',
                        4000
                    );
                    if (window?.dataLayer) {
                        window.dataLayer.push({
                            event: 'bet25.completeRegistration',
                            userId: res?.data?.userId || 0,
                        });
                        window.dataLayer.push({
                            event: 'login',
                            userId: res?.data?.userId || 0,
                        });
                    }
                    logIn();
                } else {
                    res.errorMessage &&
                        NotificationManager.error(res.errorMessage);
                }
            })
            .catch((error) => {
                NotificationManager.error('', error, 4000);
            });
    } else {
        loginUser();
        if (userId && window?.dataLayer) {
            window.dataLayer.push({
                event: 'login',
                userId: userId || 0,
            });
        }

        if (
            stayOnPrevPage &&
            stayOnPrevPage !== '/' &&
            stayOnPrevPage !== '/sport' &&
            stayOnPrevPage !== '/sport/'
        ) {
            browserHistory.push(stayOnPrevPage);
            localStorage.removeItem('stay_on_prev_page');
        } else {
            browserHistory.push('/sport/');
        }
    }

    return null;
};
